import { Bar, Doughnut } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import { useTranslation } from "react-i18next";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  LinearProgressProps,
  Box,
  LinearProgress,
  Typography,
} from "@mui/material";
import { HorizontalRule } from "@mui/icons-material";
Chart.register(...registerables);
type SentimentMeterProps = {
  sentiment: any;
  elo: number;
  noLabel?: boolean;
};

const arrowStyle = { width: "18px", height: "18px", paddingTop: "7px" };

function LinearProgressWithLabel(
  props: LinearProgressProps & { value: number; label: string }
) {
  var textColor = props.color as string;
  var sign = <HorizontalRule sx={arrowStyle} />;
  if (props.color == "success") {
    textColor = "#2e7d32";
    sign = <KeyboardArrowUpIcon sx={arrowStyle} />;
  }
  if (props.color == "error") {
    sign = <KeyboardArrowDownIcon sx={arrowStyle} />;
  }
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ minWidth: 70 }}>
        <Typography variant="body2" fontSize={"12px"} color={textColor}>
          {props.label}
        </Typography>
      </Box>
      <Box sx={{ minWidth: 60, marginLeft: "6px" }}>
        <Typography variant="body2" fontSize={"12px"} color={textColor}>
          {sign}
          {Math.round(props.value * 100) / 100}
        </Typography>
      </Box>
      <Box sx={{ width: "40%", mr: 1 }}>
        <LinearProgress
          sx={{ height: 6, borderRadius: 5, backgroundColor: "#E8E8E8" }}
          variant="determinate"
          {...props}
        />
      </Box>
    </Box>
  );
}

export function SentimentMeter(props: SentimentMeterProps) {
  const { t } = useTranslation(["common", "error", "keyword"]);
  var sum = props.sentiment
    ? props.sentiment["negative"] +
      props.sentiment["neutral"] +
      props.sentiment["positive"]
    : 100;
  const meterData = {
    labels: [t("keyword:popularity")],
    datasets: [
      {
        label: t("common:positive"),
        data: [(props.sentiment["positive"] * props.elo) / sum],
        backgroundColor: "#34E82C",
        borderColor: "#34E82C",
      },
      {
        label: t("common:neutral"),
        data: [(props.sentiment["neutral"] * props.elo) / sum],
        backgroundColor: "#81d4fa",
        borderColor: "#81d4fa",
      },
      {
        label: t("common:negative"),
        data: [(props.sentiment["negative"] * props.elo) / sum],
        backgroundColor: "#EF4C59",
        borderColor: "#EF4C59",
      },
    ],
  };

  const meterOptions = {
    maintainAspectRatio: false,
    barThickness: 16,
    barPercentage: 0.8,
    scales: {
      x: {
        min: 0,
        max: 50,
        ticks: {
          display: false,
        },
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
    indexAxis: "y" as const,
    elements: {
      bar: {
        borderWidth: 1,
      },
    },
    plugins: {
      legend: {
        position: "right" as const,
        display: props.noLabel ? !props.noLabel : true,
      },
      responsive: false,
      scales: {
        x: {
          ticks: { beginAtZero: true, min: 0, max: 200 },
          // stacked: true,
          grid: {
            display: false,
          },
        },
        y: {
          ticks: { beginAtZero: true, min: 0, max: 200 },
          // stacked: true,
          grid: {
            display: false,
          },
        },
      },
    },
  };

  console.log(props.elo * props.sentiment.negative);

  return (
    <div>
      <LinearProgressWithLabel
        variant="determinate"
        color="success"
        value={
          props.sentiment.positive
            ? (100 * props.elo * props.sentiment.positive) /
              props.sentiment.maxElo
            : 1
        }
        label={t("common:positive")}
      ></LinearProgressWithLabel>
      <LinearProgressWithLabel
        variant="determinate"
        color="info"
        value={
          props.sentiment.neutral
            ? (100 * props.elo * props.sentiment.neutral) /
              props.sentiment.maxElo
            : 1
        }
        label={t("common:neutral")}
      ></LinearProgressWithLabel>
      <LinearProgressWithLabel
        variant="determinate"
        color="error"
        value={
          props.sentiment.negative
            ? (100 * props.elo * props.sentiment.negative) /
              props.sentiment.maxElo
            : 1
        }
        label={t("common:negative")}
      ></LinearProgressWithLabel>
    </div>
  );
}
